module.exports = __webpack_public_path__ + "fonts/Montserrat-Thin.b50f5872.ttf";